<template>
	<div class="p-0 h-100 d-flex flex-column" style="overflow: hidden;">
		<div class="bg-light-noise result-topbar" style="background-color: transparent;" v-if="displayHeader">
			<nav class="navbar navbar-expand-lg navbar-light w-100 py-1 d-flex flex-row">
			  <div class="navbar-brand" v-if="$route.name === 'images'">{{$route.params.from}} - {{$route.params.to}}</div>
			  <div class="navbar-brand" v-else-if="$route.name === 'reported-images'">{{ __('translations.menu.reported_images') }}</div>
			  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			    <span class="navbar-toggler-icon"></span>
			  </button>
			  <div v-if="images.total > 0" class="collapse navbar-collapse" id="navbarSupportedContent">
			    <ul class="navbar-nav mr-auto">
			      <li class="nav-item">
				    <a class="nav-link" href="#" @click="selectAll">{{ __('translations.menu.select_all') }}</a>
				  </li>
				  <li class="nav-item">
				    <a class="nav-link" href="#" @click="selectNone">{{ __('translations.menu.deselect_all') }}</a>
				  </li>
				  <li class="nav-item">
				    <a class="nav-link" href="#" @click="tagSelectedImages" :class="{'disabled' : selectedImageIds.length === 0}">{{ __('translations.menu.add_tags') }}</a>
				  </li>
			    </ul>
			    <div v-if="displaySearchbar" class="flex-grow-1 ml-3">
			    	<searchbar :max-tags="5" :focus-on-render="false" :display-search-options="false"></searchbar>
			    </div>
			  </div>
			</nav>
		</div>
		<div class="result-content p-3" style="flex: 1; overflow-y: auto;">
	  		<div class="row">
				<section id="image-results" class="image-grid--compact cf">
					<image-result v-for="image in images.data" :key="image.image_id" :image="image" :show-toggle="$route.name ==='images'"></image-result>
				</section>
			</div>
			<div v-if="images.total == 0">
		   		<div class="text-muted">{{ __('translations.message.no_images_found') }}</div>
		    </div>
		</div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ImageResult from '../components/ImageResult'
import ImagesSelectedModal from '../components/ImagesSelectedModal'
import _ from 'lodash';

export default {
	name: "Images",
	props: ['displayHeader', 'displaySearchbar'],
	components: {
		ImageResult
	},
	computed: {
		...mapGetters([
			'images', 'selectedImageIds'
		])
	},
	created() {
		this.fetchImages();
	},
	watch: {
	    $route(to, from) {
	    	this.fetchImages();
	    }
	},
	methods: {
		fetchImages() {
			if(this.$route.name === 'images') {
				this.$store.dispatch('SELECT_IMAGES', {'from': this.$route.params.from, 'to': this.$route.params.to});
			} else if (this.$route.name === 'reported-images') {
				this.$store.dispatch('SELECT_REPORTED_IMAGES');
			}
		},
		tagSelectedImages() {
			// Retrieve image objects with its tags. 
			axios.post('/multipleImages', {ids: this.selectedImageIds}).then(response => {
				this.$modal.show(ImagesSelectedModal, {images: response.data}, {width: '100%', height: '100%'});
			}).catch(err => {
				console.log(err)
			})
		},
		selectAll() {
			this.$store.commit('SET_SELECTED_IMAGE_IDS', _.map(this.images.data, 'id'));
		},
		selectNone() {
			this.$store.commit('SET_SELECTED_IMAGE_IDS', []);
		}
	}
}
</script>